export const USERDATAEMPLOYEE_CREATE_RESET = 'USERDATAEMPLOYEE_CREATE_RESET'
export const USERDATAEMPLOYEE_CREATE_SET_CREATED = 'USERDATAEMPLOYEE_CREATE_SET_CREATED'
export const USERDATAEMPLOYEE_CREATE_SET_ERROR = 'USERDATAEMPLOYEE_CREATE_SET_ERROR'
export const USERDATAEMPLOYEE_CREATE_SET_VIOLATIONS = 'USERDATAEMPLOYEE_CREATE_SET_VIOLATIONS'
export const USERDATAEMPLOYEE_CREATE_TOGGLE_LOADING = 'USERDATAEMPLOYEE_CREATE_TOGGLE_LOADING'
